import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Axios from "axios";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import CustomDialogBox from "../../../../../Components/CustomDialogBox/CustomDialogBox";
import AddIssuedBook from "../AddIssuedBook/AddIssuedBook";
import { url } from "../../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class IssuedBookBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editStatus: false,
      issuedId: "",
      dialogOpen: false,
      notificationOpen: false,
    };
  }

  handleEdit = (issuedId) => {
    this.setState({
      editStatus: true,
      issuedId,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDialogOpen = (issuedId) => {
    this.setState({
      dialogOpen: true,
      issuedId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleDeleteIssue = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/book-issued/${this.props.bookId}/issue/${this.state.issuedId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Book issued data deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getBookDetails(this.props.bookId);
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteIssue();
      }
    }
  };

  render() {
    const { classes, data, index } = this.props;
    return this.state.editStatus === false ? (
      <TableRow>
        <TableCell align="center" style={{ padding: 0 }}>
          {index + 1}
        </TableCell>
        <TableCell align="center">{data.issuedDate}</TableCell>
        <TableCell align="center">{data.dueDate}</TableCell>
        <TableCell align="center">
          {data.returnDate ? data.returnDate : "N/A (To Be Entered)"}
        </TableCell>
        <TableCell align="center">
          {data.studentId.firstName} {data.studentId.middleName}{" "}
          {data.studentId.lastName}
        </TableCell>
        <TableCell align="center">
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleEdit(data._id)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Delete"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteIssue}
        />
      </TableRow>
    ) : (
      <AddIssuedBook
        editStatus={true}
        data={data}
        bookId={this.props.bookId}
        issuedId={this.state.issuedId}
        getBookDetails={this.props.getBookDetails}
        handleCancelEdit={this.handleCancelEdit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(IssuedBookBody)));
